import { A, H2, P } from "@expo/html-elements";
import { TextProps } from "@expo/html-elements/build/primitives/Text";
import React from "react";
import {
    Image,
    Linking,
    ScrollView,
    StyleSheet,
    Text,
    View,
} from "react-native";
import { Hoverable } from "react-native-web-hooks";
import { HoverableLink } from "../components/common/HoverableLink";
import { PrimaryButton } from "../components/common/PrimaryButton";
import { TouchableOpacity } from "../components/common/TouchableOpacity";
import { CuratorHeader } from "../components/curator/CuratorHeader";
import { SalonSignup } from "../components/salon/SalonSignup";
import { smBreakpoint } from "../constants";
import { useDimensions } from "../context/DimensionsContext";
import { useThemeState } from "../context/ThemeContext";
import {
    blackBrand,
    GTAmerica,
    GTAmericaCompressed,
    mdbreakpoint,
    PanamaBold,
    redBrand,
    TrailersDemiBold,
    wineBrand,
} from "../libs/constants";

interface Props { }

export const TermsOfServiceScreen: React.FC<Props> = () => {
    document.title = "Terms of Service | Happy Medium";
    const { theme } = useThemeState();
    const { width, height } = useDimensions();
    const styles = StyleSheet.create({
        text: {
            color: theme.foregroundColor,
        },
        secondaryHeader: {
            fontFamily: GTAmericaCompressed,
            textTransform: "uppercase",
            color: theme.foregroundColor,
            fontSize: width < smBreakpoint ? 20 : width < mdbreakpoint ? 24 : 28,
        },
        body: {
            fontFamily: GTAmerica,
            fontWeight: "300",
            fontSize: width < smBreakpoint ? 12 : width < mdbreakpoint ? 14 : 16,
        },
        infoText: {
            fontFamily: GTAmericaCompressed,
            fontSize: width < smBreakpoint ? 14 : width < mdbreakpoint ? 16 : 18,
            letterSpacing: 1.02,
        },
    });
    return (
        <ScrollView
            style={
                {
                    flex: 1,
                    backgroundColor: theme.backgroundColor,
                }}
        >
            <CuratorHeader />
            {/* <Image
        resizeMode="contain"
        source={{ uri: 'https://49market.s3.amazonaws.com/art_cafe_1.png' }}
        style={{
          width: width,
          height: width / 1.333,
          maxWidth: 1560,
          maxHeight: 1170,
          alignSelf: 'center',
        }}
      /> */}
            <View style={{ height: 40 }} />
            <View
                style={{
                    justifyContent: "center",
                    width: 700,
                    maxWidth: "90vw",
                    alignSelf: "center",
                }}
            >
                <Text
                    style={{
                        fontFamily: PanamaBold,
                        color: theme.foregroundColor,
                        textTransform: "uppercase",
                        fontSize:
                            width < smBreakpoint ? 22 : width < mdbreakpoint ? 32 : 48,
                        letterSpacing: 1.02,
                        lineHeight:
                            width < smBreakpoint ? 24 : width < mdbreakpoint ? 34 : 50,
                    }}
                >
                    Terms of Service
                </Text>
                <Text
                    style={{
                        fontFamily: GTAmerica,
                        fontWeight: "300",
                        color: theme.foregroundColor,
                        fontSize:
                            width < smBreakpoint ? 12 : width < mdbreakpoint ? 14 : 16,
                        letterSpacing: 1.07,
                    }}
                >
                    please familiarize yourself with our terms and policies before purchasing
                </Text>
                <View style={{ height: 20 }} />
                {/* <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
          <View style={{ flexDirection: 'column', justifyContent: 'center' }}>
            <Text style={styles.secondaryHeader}>Saturday, April 2nd</Text>
            <Text
              style={{
                fontFamily: GTAmerica,
                fontWeight: '300',
                color: theme.foregroundColor,
                fontSize:
                  width < smBreakpoint ? 12 : width < mdbreakpoint ? 14 : 16,
                letterSpacing: 1.07,
              }}
            >
              12:00 - 2:00PM
            </Text>
          </View>
          <View>
            <HoverableLink disabled={true} linkType="web" linkUrl={''}>
              <Hoverable>
                {(isHovered) => (
                  <View
                    style={{
                      backgroundColor: theme.foregroundColor,
                      paddingVertical: 8,
                      borderRadius: 30,
                      alignItems: 'center',
                      marginTop: 5,
                      // width: '100%',
                      // width: 250,
                      paddingHorizontal: 20,
                      // transform: [{ scale: isHovered ? 1.05 : 1 }],
                      shadowColor: blackBrand,
                      shadowOffset: { width: 5, height: 5 },
                      shadowOpacity: 0.4,
                      shadowRadius: 10,
                    }}
                  >
                    <Text
                      style={[
                        styles.infoText,
                        {
                          textTransform: 'uppercase',
                          fontWeight: '400',
                          color: theme.backgroundColor,
                        },
                      ]}
                    >
                      SOLD OUT
                    </Text>
                  </View>
                )}
              </Hoverable>
            </HoverableLink>
          </View>
        </View> */}
                <View style={{ height: 20 }} />
                <Text style={styles.secondaryHeader}>Pottery Cancellation Policy</Text>
                <Text style={[styles.text, styles.body]}>
                    Please note, our tickets are non-refundable. You must notify us at pottery@happy-medium.co at least 48 hours before your time slot in order to be eligible to reschedule. Otherwise, the full price will be forfeit.{"\n\n"}
                </Text>
                <Text style={styles.secondaryHeader}>
                    Figure Drawing Cancellation Policy
                </Text>
                <Text style={[styles.text, styles.body]}>
                    Please note, our tickets are non-refundable. You must notify us at reservations@happy-medium.co at least 24 hours before your time slot in order to be eligible to reschedule. Otherwise, the full price will be forfeit.{"\n\n"}
                </Text>
                <Text style={styles.secondaryHeader}>Class Cancellation Policy</Text>
                <Text style={[styles.text, styles.body]}>
                    Please note, our tickets are non-refundable. You must notify us at reservations@happy-medium.co at least 24 hours before your time slot in order to be eligible to reschedule. Otherwise, the full price will be forfeit.{"\n\n"}
                </Text>
                <Text style={styles.secondaryHeader}>
                    Build-a-Chair Cancellation Policy
                </Text>
                <Text style={[styles.text, styles.body]}>
                    Please note, our tickets are non-refundable. You must notify us at reservations@happy-medium.co at least 72 hours before your time slot in order to be eligible to reschedule. Otherwise, we will build your item for you and you can pick it up 1 week after the event.{"\n\n"}
                </Text>
                <Text style={styles.secondaryHeader}>
                    Large Canvas Painting Experience Cancellation Policy
                </Text>
                <Text style={[styles.text, styles.body]}>
                    Please note, our tickets are non-refundable. You must notify us at reservations@happy-medium.co at least 72 hours before your time slot in order to be eligible to reschedule. Otherwise, we will frame your blank canvas for you and you can pick it up ~10 days after the event.{"\n\n"}
                </Text>
                <Text style={styles.secondaryHeader}>
                    Art Cafe Reservation Deposit Cancellation Policy
                </Text>
                <Text style={[styles.text, styles.body]}>
                    Please note, Art Cafe deposits are non-refundable. You must notify us at reservations@happy-medium.co at least 24 hours before your time slot if someone cannot make it in order to be eligible for a credit that can be used towards any of our events or products, otherwise the deposit will be forfeit.{"\n\n"}
                </Text>
                <Text style={styles.secondaryHeader}>
                    What happens if it rains on the day of my class or figure drawing?
                </Text>
                <Text style={[styles.text, styles.body]}>
                    We're excited to host events in our garden in Greenpoint. All garden events will take place rain or shine and there will be no exceptions made to our usual reschedule policy for weather. In addition to umbrellas provided by Happy Medium, we encourage guests to dress appropriately for the weather. Should Happy Medium choose to cancel the event, we will be in touch to issue a credit or refund.{"\n\n"}
                </Text>
                <Text style={styles.secondaryHeader}>Gift Card Return Policy</Text>
                <Text style={[styles.text, styles.body]}>
                    Gift Cards are non-returnable and non-refundable.{"\n\n"}
                </Text>
                <Text style={styles.secondaryHeader}>
                    Merch Return Policy
                </Text>
                <Text style={[styles.text, styles.body]}>
                    Merch including, but not limited to, hats, posters, and shirts are non-returnable and nonrefundable.{"\n\n"}
                </Text>
                <Text style={styles.secondaryHeader}>Questions?</Text>
                <Text style={[styles.text, styles.body]}>
                    Please email reservations@happy-medium.co for any questions related to tickets.{"\n\n"}
                </Text>

                <Text style={styles.secondaryHeader}> HAPPY MEDIUM TERMS & CONDITIONS</Text>
                <Text style={[styles.text, styles.body]}>
                    Terms and Conditions, Waiver, and Release Form (“Terms and Conditions”)
                </Text>
                <Text style={[styles.text, styles.body]}>
                    In consideration of being allowed to participate in and attend any Happy Medium Creative Goods Inc., event or classes, I agree to comply with any and all rules, regulations, terms, and conditions of the Happy Medium Creative Goods Inc. Event, including but not limited to the following:
                </Text>

                <Text style={[styles.text, styles.body]}>
                    <Text style={{ fontWeight: 'bold' }}>Data{'\n'}</Text>
                    I grant Happy Medium Creative Goods Inc. rights to use my email address or phone number from this transaction to contact me regarding future Happy Medium Creative Goods Inc. events and/or to share Happy Medium Creative Goods Inc. content. Happy Medium Creative Goods Inc., may store my email address and city of my Happy Medium Creative Goods Inc., event attendance for the purposes of inviting me to future events in the same city. Happy Medium Creative Goods Inc., will not share my email address with any outside company without my prior proactive consent. Happy Medium Creative Goods Inc., can be contacted with any questions or concerns around data at reservations@happy-medium.co.
                </Text>
                <P style={[styles.text, styles.body]}>
                    <Text style={[styles.text, styles.body, { fontWeight: 'bold' }]}>Health and Safety{'\n'}</Text>
                    I certify that I am physically able to participate in the Happy Medium Creative Goods Inc., Event and in any associated activity or performance, and that I have not been advised otherwise by a qualified medical professional.
                </P>
                <P style={[styles.text, styles.body]}>
                    I acknowledge and fully understand that as a participant, I will be engaging in activities that involve risk of serious injury, including permanent disability and death, risk of illness or disease (including potential exposure to COVID 19 or other deadly viruses), property loss and severe social and economic losses. These risks include, but are not limited to, those caused by: (a) the actions, inactions, or negligence of the organizers of the Happy Medium Creative Goods Inc., its officers, directors, employees, agents, representatives, volunteers, contractors, licensees and/or any person or company formally or informally affiliated with Happy Medium Creative Goods Inc., (collectively, “HAPPY MEDIUM”) and/or participants in the Event; (b) conditions of the premises or equipment used; (c) rules and regulations regarding the activities; and (f) the condition of participants.
                </P>
                <P style={[styles.text, styles.body]}>
                    I further acknowledge and fully understand that there may also be other risks that are not known or foreseeable at this time. I KNOWINGLY AND VOLUNTARILY ASSUME ALL RISK OF PROPERTY LOSS, PERSONAL INJURY, SERIOUS INJURY, OR DEATH, WHICH MAY OCCUR BY ATTENDING THE HAPPY MEDIUM CREATIVE GOODS INC., EVENT, AND HEREBY FOREVER RELEASE, DISCHARGE, AND HOLD HAPPY MEDIUM CREATIVE GOODS INC., HARMLESS FROM ANY CLAIM ARISING FROM SUCH RISK, EVEN IF ARISING FROM THE NEGLIGENCE OF HAPPY MEDIUM CREATIVE GOODS INC, OR FROM THIRD PARTIES, AND I ASSUME FULL RESPONSIBILITY AND LIABILITY FOR MY PARTICIPATION.
                </P>
                <P style={[styles.text, styles.body]}>
                    I, on behalf of myself, my heirs, executors, administrators and assigns, hereby waive, release, discharge, and agree not to sue HAPPY MEDIUM,  its officers, directors, members, employees, volunteers, representatives, agents, contractors and subcontractors, and other participants, sponsors, affiliates, and if applicable, owners and lessors of equipment, (collectively the “Releasees”), from any and all claims for damages, injuries, losses, liabilities and expenses that I may have or that may subsequently accrue to me, relating to, resulting from or arising out of my use and/or participation in the Happy Medium Creative Goods Inc., Event, including any programs or activities at the Event, and including any injury or damage to my person or property, or to that of any other person or property. However, if Happy Medium Creative Goods Inc., files a claim against me, I may file a counterclaim related to the same facts and circumstances.
                </P>
                <P style={[styles.text, styles.body]}>
                    I agree to indemnify, defend, and hold the Releasees harmless from and against any and all claims by third parties for damages, injuries, losses, liabilities and expenses relating to, resulting from or arising out of my participation in the Happy Medium Creative Goods Inc. Event, including in any program, event or activity at the Event. I intend that the waiver and release of liability contained in these Terms and Conditions shall be construed broadly to provide a release and waiver to the maximum extent permissible under applicable law.
                </P>
                <P style={[styles.text, styles.body]}>
                    I acknowledge that Happy Medium Creative Goods Inc. has the right to remove or exclude any person from the Happy Medium Creative Goods Inc. Event for any reason or no reason at all at its sole discretion.
                </P>
                <P style={[styles.text, styles.body]}>
                    <Text style={[styles.text, styles.body, { fontWeight: 'bold' }]}>Age Restrictions{'\n'}</Text>
                    I understand that children under 18 years of age can attend the event only accompanied by a parent or guardian, and that if I bring a minor to the event I agree to the contractual terms contained in these Terms and Conditions on behalf of the minor.
                </P>
                <P style={[styles.text, styles.body]}>
                    If I am obtaining tickets for, or providing any tickets to, any other person(s), I recognize that I am acting as that person’s agent in obtaining the tickets and/or vehicle passes, and due to this agency relationship, I agree to these Terms and Conditions on behalf of any person to whom I deliver any of the tickets I obtain, and I shall notify any such person of these Terms and Conditions when I deliver a ticket to them. If I have obtained a ticket from another person, I also agree to these Terms and Conditions when the ticket is delivered to me.
                </P>
                <P style={[styles.text, styles.body]}>
                    <Text style={[styles.text, styles.body, { fontWeight: 'bold' }]}>Liability{'\n'}</Text>
                    I agree that Happy Medium Creative Goods Inc. is not liable for acts of God, the weather, strikes, protests, or actions taken by government agencies and similar causes. I understand that tickets are nonrefundable even if the Event is terminated early or canceled, or entry conditions are modified, due to harsh weather, acts of nature, governmental regulation, the failure to obtain required governmental permits, or conditions beyond Happy Medium Creative Goods Inc. 's control. All sales are final. No refunds or exchanges will be issued for any reason. Fees are non-refundable.
                </P>
                <P style={[styles.text, styles.body]}>
                    <Text style={[styles.text, styles.body, { fontWeight: 'bold' }]}>Image Release Notice{'\n'}</Text>
                    By attending and participating in activities hosted by Happy Medium Creative Goods, Inc., you grant Happy Medium and its affiliates the right to take photographs, video, and audio recordings of you and your artwork. You also grant permission for these images, videos, and recordings to be used for promotional, marketing, and educational purposes, including but not limited to social media, websites, and printed materials.

                </P>
                <P style={[styles.text, styles.body]}>
                    You understand that no compensation will be provided for this use, and thatHappy Medium will use the media respectfully and appropriately.
                </P>
                <P style={[styles.text, styles.body]}>
                    If you do not wish to be photographed or recorded, please notify a staff member at check-in.
                </P>
                <P style={[styles.text, styles.body]}>
                    I hereby grant all clearances, copyright and otherwise, for the use of my name, likeness, image, voice, appearance and performance embodied in the content.  I expressly release and indemnify Happy Medium Creative Goods Inc. and its officers, employees, agents and designees from any and all claims known or unknown arising out of or in any way connected with the above granted uses and representations.  The rights granted Happy Medium Creative Goods Inc. herein are perpetual and worldwide.
                </P>
                <P style={[styles.text, styles.body]}>
                    This Agreement shall be governed by and construed in accordance with the laws of the state of New York without regard to the conflicts of laws provisions thereof. Any disputes relating to this Agreement shall be dealt with through arbitration. Arbitration proceedings shall be conducted under the Rules of Commercial Arbitration of the AAA (the "Rules").
                </P>
                <P style={[styles.text, styles.body]}>
                    Happy Medium Creative Goods Inc. reserves the right, at its sole discretion, to modify or replace any of these Terms and Conditions, or change, suspend, or discontinue the Event at any time by posting a notice on its website or by email. Your attendance at the Event following the posting of any changes to these Terms of Use constitutes acceptance of those changes.
                </P>





                <View style={{ height: 60 }} />
            </View>
            <View style={{ height: 60 }} />
            <SalonSignup />
        </ScrollView>
    );
};
